
<script>
import VueGallery from 'vue-gallery'

export default {
  name: 'photo',
  components: {
    gallery: VueGallery
  },
  props: {
    data: {
      type: Object,
      default: () => null
    }
  },
  data: () => ({
    index: null
  })
}
</script>

<template>
  <div class="cart__hotel-photo">
    <img
      v-lazyload
      src="@/assets/images/default.jpg"
      :data-src="data.headImage"
      @click="index = 0"
    >
    <span>{{ data.total }} фото</span>
    <gallery
      :images="data.images"
      :index="index"
      @close="index = null"
    />
  </div>
</template>
